export default "__VITE_ASSET__5748c18c__"